import React, { useState } from "react";
import "../styles/Loans.css";

const Loans = () => {
    const [activeLoan, setActiveLoan] = useState(null);

    const loans = [
        {
            key: "vehicle",
            title: "Vehicle Loan",
            img: "https://media.istockphoto.com/id/2148500100/photo/couple-in-the-bank-stuck-photo.webp?a=1&b=1&s=612x612&w=0&k=20&c=tCstND1PGeLiUE9D7jqf8nHQFfOYbJ7VOrvCRhPbPTE=",
        },
        {
            key: "home",
            title: "Home Loan",
            img: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8aG9tZSUyMGxvYW58ZW58MHx8MHx8fDA%3D",
        },
        {
            key: "mortgage",
            title: "Mortgage Loan",
            img: "https://images.unsplash.com/photo-1723095136747-20a24afcee20?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fE1vcnRnYWdlJTIwTG9hbnxlbnwwfHwwfHx8MA%3D%3D",
        },
        {
            key: "education",
            title: "Education Loan",
            img: "https://media.istockphoto.com/id/1614160981/photo/portrait-of-happy-indian-farmer-father-and-daughter-holding-clay-money-box-or-gullak-smiling.jpg?s=612x612&w=0&k=20&c=DXfAcLLGPa9IoVk1OcET3bhJ-OrjeQswSzx59lrPKv0=",
        },
        {
            key: "gold",
            title: "Gold Loan",
            img: "https://images.unsplash.com/photo-1681183521111-8708accf2800?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Z29sZCUyMGxvYW58ZW58MHx8MHx8fDA%3D",
        },
    ];

    const loanDetails = {
        vehicle: {
            description:
                "The Sahyadri Sahakari Bank Ltd offers Vehicle Loans to help you purchase your dream two-wheeler or four-wheeler with ease. Our loan comes with competitive interest rates, flexible repayment tenure, and quick approval process. Whether it is for personal use or business requirements, we ensure smooth financing support tailored to your needs.",
            eligibility:
                "Applicants must be above 21 years of age with a stable source of income. Salaried individuals, self-employed professionals, and business owners can apply by submitting valid KYC documents and income proof. A good repayment history strengthens the approval process.",
            process:
                "The process begins with submitting a simple application form along with required documents. After verification and assessment, the loan is approved and sanctioned. Upon completion of formalities, the loan amount is disbursed directly for vehicle purchase.",
            margin:
                "For personal use: 80% of invoice (20% margin)\n" +
                "For commercial: 20% (on Cost + Registration Charges + Insurance)\n" +
                "For used cars: 50% ",
            repayment: "New Car: Maximum 60 months\nUsed car: Maximum 60 months*",
            security: " Hypothecation of the Car to be purchased",
        },
        home: {
            description:
                "Our Home Loan is designed to turn your dream of owning a home into reality. We provide affordable interest rates, longer repayment tenures, and transparent policies to ensure financial comfort. The Sahyadri Sahakari Bank Ltd supports you at every stage of your home-buying journey.",
            eligibility:
                "Individuals aged 21 years and above with stable employment or business income are eligible. Applicants must provide income proof, property documents, and valid identification. Loan approval depends on repayment capacity and credit assessment.",
            process:
                "Submit the loan application with property and income documents. After evaluation and property verification, the loan is sanctioned. The disbursed amount is released as per construction stage or seller agreement.",
            margin:
                "Loan amount upto Rs. 35 lacs : 15% of Agreement value or Market Value whichever is lower\n" +
                "Loan amount above Rs. 35 lacs : 15% of Agreement Value + Stamp Duty + Reg or Market Value whichever is lower ",
            repayment: "Maximum 20 years for Salaried class / Professionals",
            security: "Mortgage of residential premises to be purchased",
        },
        mortgage: {
            description:
                "Mortgage Loan allows you to unlock the value of your residential or commercial property to meet personal or business financial needs. We offer flexible repayment options and secure processing backed by trust and transparency.",
            eligibility:
                "Property owners above 21 years with clear ownership documents can apply. Income proof and KYC documents are required for evaluation. Loan eligibility is assessed based on property value and repayment ability.",
            process:
                "After submitting the application and property documents, the bank conducts valuation and verification of legal papers. Once approved, the sanctioned amount will be disbursed after completing legal formalities ap per agreed terms and conditions as per sanctioned letter.",
            margin:
                "40% Of Realisable Value",
            repayment: "Maximum 120 months by way of EMIs",
            security:
                "Mortgage of commercial premises to be purchased\n" +
                "Mortgage of residential property\n"+
                "Open plot of land and agricultural land(Available in Satara Branch",
        },
        education: {
            description:
                "Our Education Loan supports students in pursuing higher education in India or abroad. We provide financial assistance covering tuition fees, examination fees, and other academic expenses with flexible repayment options.",
            eligibility:
                "Students with confirmed admission in recognized institutions can apply with a co-applicant such as a parent or guardian. Necessary academic records, admission proof, and KYC documents are required.",
            process:
                "Submit the loan application along with admission confirmation and fee structure. Upon verification and approval, the loan amount is disbursed directly to the institution as per requirement.",
            margin:
                "No Specific Directions",
            repayment: "Maximum 180 months",
            security:
                "For loan above 5 lakhs 50% of mortgage of security is required.",
        },
        gold: {
            description:
                "Gold Loan at The Sahyadri Sahakari Bank Ltd provides instant liquidity against your gold ornaments. With minimal documentation and fast processing, it is an ideal solution for urgent financial requirements.",
            eligibility:
                "Individuals above 18 years owning gold ornaments can apply. Basic KYC documents are required for verification. Loan amount depends on purity and weight of gold pledged.",
            process:
                "Gold valuation to be done. After assessment and document verification, the loan is approved instantly and the disbursed amount will be credited to account on the same day.",
            margin:
                "For exposure up to ₹2.5 lakh, the margin is 15% on valuation.\n" +
                "For exposure between ₹2.5 lakh and ₹5 lakh, the margin is 20% on valuation.\n" +
                "For exposure above ₹5 lakh, the margin is 25% on valuation.\nThe benchmark rate for gold is currently set at ₹12,000/- per tola.",
            repayment: "",
            security: "Pledge of gold ornaments/Jewellery\n",
        },
    };

    return (
        <div className="loans-page">
            {/* HERO */}
            <section className="loans-hero">
                <h1>Loans</h1>
                <p>Empowering Your Dreams With Trusted Financial Support</p>
            </section>

            {/* INTRO */}
            <section className="loans-intro container">
                <h2>Flexible Loan Solutions Designed For You</h2>
                <p>
                    The Sahyadri Sahakari Bank Ltd offers a range of financial products crafted to support your personal and professional growth. Whether you are looking to fulfil a lifelong dream, expand your business, manage an unexpected expense, or invest in your future, we have a lending solution that fits your needs perfectly.
                    Our loan products are built with you in mind — offering flexible repayment tenures, competitive interest rates, and minimal documentation so that the borrowing process is as smooth and stress-free as possible. We understand that every individual and every business is different, which is why we do not believe in a one-size-fits-all approach. Instead, we work closely with you to design a loan plan that aligns with your financial goals and repayment capacity.
                    Our focus on transparency means you will never encounter hidden charges or complicated terms. From the moment you apply to the day your loan is fully repaid, we keep you informed and in control every step of the way. Affordability is at the heart of everything we do, ensuring that quality financial support remains accessible to all — whether you are a salaried professional, a self-employed individual, or a growing business owner.
                </p>
                <h2>Empowering Your Financial Journey, Every Step of the Way</h2>
                <p>
                    At The Sahyadri Sahakari Bank Ltd, we believe every dream deserves the right support. Our thoughtfully designed loan products are built around your unique needs — whether you're growing a business, building a home, or planning for the future. With competitive rates, simple processes, and a team that truly cares, we make borrowing feel less like a transaction and more like a partnership.
                    <h4>Smart Lending. Trusted Banking.</h4>
                    <p>
                        The Sahyadri Sahakari Bank Ltd brings you a comprehensive suite of loan solutions tailored to meet the demands of modern life. Rooted in the values of trust, integrity, and member-first service, our financial products offer flexible repayment options, minimal documentation, and swift approvals — because your goals shouldn't wait.
                    </p>
                    <h4>Loans That Work as Hard as You Do</h4>
                    <p>
                        Whether you're an entrepreneur looking to expand or an individual planning a major milestone, The Sahyadri Sahakari Bank Ltd has a lending solution for you. We combine the reliability of a trusted cooperative bank with the convenience of hassle-free loan processing, giving you access to funds when you need them most.
                    </p>
                    <h4>Banking on Community. Built on Trust.</h4>
                    <p>
                        For decades, The Sahyadri Sahakari Bank Ltd has stood beside its members as a financial partner they can count on. Our loan offerings are designed not just to meet financial needs, but to uplift lives, strengthen businesses, and build a stronger community — one loan at a time.
                    </p>
                </p>
            </section>

            {/* ===== NEW SECTION: LOAN CTA WITH VIDEO ===== */}
            <section className="loan-cta-section">
                <div className="loan-cta-inner">
                    {/* LEFT: Text */}
                    <div className="loan-cta-text">
                        <span className="cta-badge">Quick &amp; Easy</span>
                        <h2>Interested in Taking a Loan?</h2>
                        <p>
                            Share your interest with us and our team will get back to you with the best loan offer tailored just for you. Whether it's a vehicle, home, education, or gold loan — we have got you covered.
                        </p>

                        <a href="/loan-enquiry" className="loanpage-cta-btn">
                            Share Your Interest
                        </a>
                    </div>

                    {/* RIGHT: Video */}
                    <div className="loan-cta-video">
                        <video
                            src="/loan-animation.mp4"
                            autoPlay
                            loop
                            muted
                            playsInline
                            className="cta-video"
                        />
                    </div>
                </div>
            </section>
            {/* ===== END NEW SECTION ===== */}

            {/* LOAN CARDS */}
            <section className="loan-cards container">
                {loans.map((loan) => (
                    <div
                        key={loan.key}
                        className="loan-card"
                        style={{ backgroundImage: `url(${loan.img})` }}
                    >
                        <div className="overlay">
                            <h3>{loan.title}</h3>
                            <a href="#loan-details-section">
                                <button onClick={() => setActiveLoan(loan.key)}>
                                    Know More
                                </button>
                            </a>
                        </div>
                    </div>
                ))}
            </section>

            {/* DETAILS SECTION */}
            {activeLoan && (
                <section className="loan-details container" id="loan-details-section">
                    <h2>{loans.find((l) => l.key === activeLoan).title}</h2>

                    <h3>Description</h3>
                    <p>{loanDetails[activeLoan].description}</p>

                    <h3>Eligibility</h3>
                    <p>{loanDetails[activeLoan].eligibility}</p>

                    <h3>Process</h3>
                    <p>{loanDetails[activeLoan].process}</p>

                    <h3>Margin</h3>
                    <p>{loanDetails[activeLoan].margin}</p>
                    <h3>Repayment</h3>
                    <p>{loanDetails[activeLoan].repayment}</p>
                    <h3>Security</h3>
                    <p>{loanDetails[activeLoan].security}</p>
                    <div className="details-buttons">
                        <a href="/loan-enquiry" className="enquiry-btn">
                            Make an Enquiry
                        </a>
                    </div>
                </section>
            )}

            {/* WHY SECTION */}
            <section className="why-loan container">
                <h2>Why Take Loan From Sahyadri Sahakari Bank?</h2>
                <div className="why-grid">
                    <div className="why-card">
                        <h4>Competitive Interest Rates</h4>
                        <p>
                            We offer attractive interest rates designed to reduce your
                            financial burden and make repayment convenient.
                        </p>
                    </div>
                    <div className="why-card">
                        <h4>Quick Processing</h4>
                        <p>
                            Our streamlined process ensures faster approvals and minimal
                            documentation.
                        </p>
                    </div>
                    <div className="why-card">
                        <h4>Transparent Policies</h4>
                        <p>
                            No hidden charges and complete clarity in terms and conditions.
                        </p>
                    </div>
                    <div className="why-card">
                        <h4>Trusted Institution</h4>
                        <p>
                            Serving customers with integrity and reliability for years.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Loans;